import {template} from 'lodash';
import {markdown} from "markdown"

const $teamCarouselMobile = $('#teamCarouselMobileTmpl');
const $teamCarouselFullsize = $('#teamCarouselFullsizeTmpl');
const teamMobileTmpl = template($teamCarouselMobile.html());
const teamFullsizeTmpl = template($teamCarouselFullsize.html());
let teamContext = window.teamContext;

/**
 * Sample context
 */
if (!teamContext) teamContext = {
  items: [
    {
      name: 'Егор Переудин',
      role: 'Тренер по гимнастике для старших групп',
      about: '  ',
      photo: './img/team2.png',
    },
    {
      name: 'Алина Тарасова',
      role: 'Тренер по гимнастике для младших групп',
      about: ``,
      photo: './img/team3.png',
    },
    {
      name: 'Виктория Захарова',
      role: 'Педагог раннего развития, педагог АВС Театр',
      about: ``,
      photo: './img/team4.png',
    },
    {
      name: 'Ольга Авраамова',
      role: 'Педагог раннего развития, педагог АВС MUSIC',
      about: ``,
      photo: './img/team5.png',
    },
    {
      name: 'Анастасия Тарачанова',
      role: 'Администратор',
      about: ``,
      photo: './img/team6.png',
    },
    {
      name: 'Людмила Новикова',
      role: 'Администратор',
      about: ``,
      photo: './img/team7.png',
    },
    {
      name: 'Катерина-Кристина Гершуни',
      role: 'CEO, душа клуба',
      about: ``,
      photo: './img/team1.png',
    },
  ]
};

teamContext.markdown = markdown;

// console.log('teamContext: ',window.teamContext);

//console.log(teamTmpl(teamContext));

if (teamContext) {
  $teamCarouselMobile.replaceWith(teamMobileTmpl(teamContext));
  $teamCarouselFullsize.replaceWith(teamFullsizeTmpl(teamContext));
  initTeamCarouselFullsize();
}

function initTeamCarouselFullsize() {
  const $carouselBtns = $('a[data-slide]');

// Prevent page from scrolling
  $carouselBtns.click((e) => {
    e.preventDefault();
  });

// Create infinite 3x carousel

  const $fullsizeTeamCarousel = $('#teamCarouselFullsizeControls');

  $fullsizeTeamCarousel.find('.carousel-item').each(function () {
    let next = $(this).next();
    if (!next.length) {
      next = $(this).siblings(':first');
    }
    next.children(':first-child').clone().appendTo($(this));

    if (next.next().length > 0) {
      next.next().children(':first-child').clone().appendTo($(this));
    }
    else {
      $(this).siblings(':first').children(':first-child').clone().appendTo($(this));
    }
  });
}


// WEBPACK FOOTER //
// ./src/js/team-carousel.js